module.exports = __webpack_public_path__ + "img/gongzimingxi.06d37a22.png";